module.exports = __webpack_public_path__ + "static/img/9a9df2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/qhRecommendOpenAccount/images/lhmj.png
// module id = 677
// module chunks = 2